export interface Lesson {
  title: string;
  url: string;
}

export interface Tier {
  id: string;
  label: string;
  tagline: string;
  lessons: Lesson[];
}

const curriculum: Tier[] = [
  {
    id: 'beginner',
    label: 'Beginner',
    tagline: 'Start your trading journey from zero',
    lessons: [
      {
        title: 'What is the Stock Market?',
        url: 'https://www.youtube.com/results?search_query=what+is+the+stock+market+explained+for+beginners',
      },
      {
        title: 'How to Open a Brokerage Account',
        url: 'https://www.youtube.com/results?search_query=how+to+open+a+brokerage+account+step+by+step',
      },
      {
        title: 'Reading Candlestick Charts 101',
        url: 'https://www.youtube.com/results?search_query=candlestick+charts+101+beginners+guide',
      },
      {
        title: 'Support & Resistance Levels',
        url: 'https://www.youtube.com/results?search_query=support+and+resistance+levels+trading+explained',
      },
      {
        title: 'Introduction to Moving Averages',
        url: 'https://www.youtube.com/results?search_query=moving+averages+introduction+trading',
      },
      {
        title: 'Market Orders vs Limit Orders',
        url: 'https://www.youtube.com/results?search_query=market+orders+vs+limit+orders+explained',
      },
      {
        title: 'Your First Stock Trade (Step-by-Step)',
        url: 'https://www.youtube.com/results?search_query=how+to+buy+your+first+stock+step+by+step',
      },
    ],
  },
  {
    id: 'intermediate',
    label: 'Intermediate',
    tagline: 'Level up with options, crypto & strategy',
    lessons: [
      {
        title: 'Options Trading Basics: Calls & Puts',
        url: 'https://www.youtube.com/results?search_query=options+trading+basics+calls+and+puts+explained',
      },
      {
        title: 'Understanding The Greeks (Delta, Gamma, Theta, Vega)',
        url: 'https://www.youtube.com/results?search_query=options+greeks+delta+gamma+theta+vega+explained',
      },
      {
        title: 'Cryptocurrency Fundamentals',
        url: 'https://www.youtube.com/results?search_query=cryptocurrency+fundamentals+for+beginners',
      },
      {
        title: 'Chart Patterns That Actually Work',
        url: 'https://www.youtube.com/results?search_query=chart+patterns+that+work+trading',
      },
      {
        title: 'Trend Trading Strategies',
        url: 'https://www.youtube.com/results?search_query=trend+trading+strategies+for+beginners',
      },
      {
        title: 'Risk Management Essentials',
        url: 'https://www.youtube.com/results?search_query=risk+management+trading+essentials',
      },
      {
        title: 'Real Estate Investing 101',
        url: 'https://www.youtube.com/results?search_query=real+estate+investing+101+for+beginners',
      },
    ],
  },
  {
    id: 'advanced',
    label: 'Advanced',
    tagline: 'Master the markets like a pro',
    lessons: [
      {
        title: 'Options Strategies: Spreads, Straddles, Condors',
        url: 'https://www.youtube.com/results?search_query=options+strategies+spreads+straddles+iron+condors',
      },
      {
        title: 'Event-Driven Trading (Earnings, Fed Decisions)',
        url: 'https://www.youtube.com/results?search_query=event+driven+trading+earnings+fed+decisions',
      },
      {
        title: 'Macro Trading & Market Analysis',
        url: 'https://www.youtube.com/results?search_query=macro+trading+market+analysis+strategy',
      },
      {
        title: 'Technical Analysis Deep Dive',
        url: 'https://www.youtube.com/results?search_query=technical+analysis+deep+dive+advanced',
      },
      {
        title: 'Crypto Advanced: DeFi & Trading',
        url: 'https://www.youtube.com/results?search_query=defi+advanced+crypto+trading+strategies',
      },
      {
        title: 'Portfolio Management & Diversification',
        url: 'https://www.youtube.com/results?search_query=portfolio+management+diversification+strategy',
      },
      {
        title: 'Building Your Trading System',
        url: 'https://www.youtube.com/results?search_query=building+a+trading+system+from+scratch',
      },
    ],
  },
];

export default curriculum;
